import { CommitteeManagementPageContent } from "./_components/CommitteeManagementPageContent";

export default function ActiveCommitteesPage() {
  return <CommitteeManagementPageContent activeTab="active" />;
}
